import React, { useState, useEffect } from "react";
import config, { API_PKI } from "../../config";
import { useTranslation } from "react-i18next";
import PageWrapper from "../../component/PageWrapper";
const SDKUserSuccess = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("SDKUserForm.successTitle")}>
      <p>
        {t("SDKUserForm.successText1")}{" "}
        <a href="/get-sdk">
          {t("SDKUserForm.successText2")}
        </a>{" "}
        {t("SDKUserForm.successText3")}
      </p>
    </PageWrapper>
  );
};

export default SDKUserSuccess;
